/**
 * External Imports
 */
import styled from 'styled-components';

export const DateContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

export const SelectContainer = styled.div`
  width: 48.5%;
`;
